import { render, staticRenderFns } from "./KzsAdd.vue?vue&type=template&id=c27ba4e2"
import script from "./KzsAdd.vue?vue&type=script&lang=js"
export * from "./KzsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports